export enum EstateRagDocumentSourceTypeKey {
  NOTION = 'notion',
  LEGAL_REASONING = 'legal_reasoning',
  CONTENT_LIBRARY = 'content_library',
  ESTATE_LAW = 'estate_law',
  INTERNET_RESOURCE = 'internet_resource'
}
